// all analytics track calls should be linked to a constant here

export const TRACK_FE_PERFORMANCE_DURATION = "FE Performance Duration";
